import styled from 'styled-components';

const StyledMainPage = styled.div`
  max-width: 100%;
  padding: 30px 0 75px 0;
  flex: 1 0 auto;

  .container {
    max-width: 1170px;
    margin: auto;
    padding: 0 15px;
  }
  .error-text {
      text-align: center;
      color: white;
    }
  }
`;

export default StyledMainPage;
